import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2 } from 'lucide-react';
const symptoms = ['Every morning you need several minutes before you can move normally', 'You take the stairs carefully because your knees crack or hurt', "You've tried glucosamine, collagen and chondroitin supplements without lasting results", 'Your doctor says "it\'s normal for your age" but something inside you knows it shouldn\'t be', 'Cold and humidity make your pain worse in a predictable way', 'You feel like your body no longer responds the way it used to', "You've relied on ibuprofen or acetaminophen more than you'd like to admit"];
export function SymptomIdentification() {
  return <section className="bg-cream py-12 md:py-16 px-4 sm:px-6 lg:px-8" data-id="element-202">
      <div className="max-w-3xl mx-auto" data-id="element-203">
        <FadeIn data-id="element-204">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-black mb-12" data-id="element-205">
            Do Any of These Sound Familiar?
          </h2>
        </FadeIn>

        <div className="space-y-4 mb-12" data-id="element-206">
          {symptoms.map((symptom, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-207">
              <div className="bg-white p-5 rounded-lg shadow-sm border border-gray-100 flex items-start gap-4" data-id="element-208">
                <CheckCircle2 className="w-6 h-6 text-sage-green flex-shrink-0 mt-0.5" data-id="element-209" />
                <p className="text-lg text-gray-800" data-id="element-210">{symptom}</p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.8} data-id="element-211">
          <div className="text-center bg-white/50 p-6 rounded-xl border border-gold/20" data-id="element-212">
            <p className="text-xl font-semibold text-forest-green leading-relaxed" data-id="element-213">
              If you checked 3 or more: you're not aging badly. You have an
              active internal fire that nobody has explained how to put out.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}